export class WorldModuleLoadError extends Error {
  constructor(cause: unknown) {
    super(cause instanceof Error ? cause.message : 'The village code could not be loaded.', {
      cause,
    });
    this.name = 'WorldModuleLoadError';
  }
}
